import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_ENV==='production'?'https://anti-stigma.com':'https://stage.synapse.mdataws.com'
});

export default instance;